import { Link as ReactRouterLink } from 'react-router';

import { Flex, MenuItem, Text } from '@chakra-ui/react';

import { isDefined } from '@enterprise/core';

import type { RadioMenuItemProps } from './types/radio-menu-item.props';

const RadioMenuItem = ({ children, icon, isSelected = false, onClick, ...props }: RadioMenuItemProps) => {
  return (
    <MenuItem
      _hover={{ bg: 'hsp.500', color: 'white' }}
      as={ReactRouterLink}
      cursor="pointer"
      onClick={onClick}
      {...props}
      p={3}>
      <Flex
        align="center"
        gap={4}
        w="full">
        <Flex
          align="center"
          as="span"
          w={5}>
          {isSelected && isDefined(icon) ? icon : null}
        </Flex>
        <Text
          flex="1"
          fontWeight={isSelected ? 'semibold' : 'normal'}>
          {children}
        </Text>
      </Flex>
    </MenuItem>
  );
};

export default RadioMenuItem;
